import packageJson from '../../package.json';

// Setting a global variable `clientVersion` to the version number from package.json.
// This makes the version number accessible globally in the application.
global.clientVersion = packageJson.version;